import { useTheme } from 'styled-components';
import { useQuery } from '@apollo/client';

import { Typography } from '@libs/components';
import { useApiResponse } from '@libs/hooks';
import { CurrencyType } from '@libs/types';
import { ExchangeModeEnum } from '@libs/backend-common';
import { formatBalance, getPercentageWithSymbol } from '@libs/helpers';

import { useTranslation } from 'src/hooks';
import { getCurrencySymbol } from 'src/helpers';
import { getExchangeFeesWithRangesQuery } from 'src/gql';

import { Body, Container, StatWrapper, Title, StatusBar } from './styles';

type ConvertComissionProps = {
  exchangeFeeId?: string;
  selectedAssetCode?: CurrencyType;
};
const ConvertCommission: React.FC<ConvertComissionProps> = ({
  exchangeFeeId,
  selectedAssetCode = CurrencyType.USD,
}) => {
  const { colors } = useTheme();

  const { t } = useTranslation();

  const getExchangeFeesWithRangesResp = useQuery(
    getExchangeFeesWithRangesQuery,
    {
      variables: {
        record: {
          valueAssetCode: selectedAssetCode,
          mode: ExchangeModeEnum.CONVERT,
        },
      },
      fetchPolicy: 'network-only',
    }
  );

  const { response: getExchangeFeesWithRangesResponse } = useApiResponse(
    getExchangeFeesWithRangesResp
  );
  const userVolume =
    getExchangeFeesWithRangesResponse?.getExchangeFeesWithRanges.userVolume;

  return (
    <Container>
      <Title type="bodyButton" fontFamily="primaryMedium">
        {t('common_fee_short')}
      </Title>
      <Body>
        {getExchangeFeesWithRangesResponse?.getExchangeFeesWithRanges.data.map(
          (currentItem, index, array) => {
            const nextItem = array[index + 1];
            const currencySign = getCurrencySymbol(selectedAssetCode);
            const toAmount = nextItem
              ? `-${formatBalance(
                  nextItem.greaterThan,
                  false,
                  0
                )}${currencySign}`
              : ' +';

            const defaultActiveRange =
              Number(userVolume) <= array[index + 1]?.greaterThan &&
              Number(userVolume) >= array[index].greaterThan;
            const currentActiveRange = exchangeFeeId === currentItem.id;

            const isActive = exchangeFeeId
              ? currentActiveRange
              : defaultActiveRange;

            return (
              <StatWrapper key={index}>
                <StatusBar isActive={isActive} />
                <Typography
                  type="bodyButton"
                  fontFamily="primaryBold"
                  color={
                    !isActive
                      ? colors.text.secondary
                      : colors.interactive.brandColor
                  }
                >
                  {getPercentageWithSymbol(currentItem.buyRate)}
                </Typography>
                <Typography
                  type="bodyButton"
                  fontFamily="primaryRegular"
                  color={
                    !isActive
                      ? colors.text.secondary
                      : colors.interactive.brandColor
                  }
                >
                  {formatBalance(currentItem.greaterThan, false, 0)}
                  {!nextItem ? currencySign : ''}
                  {toAmount}
                </Typography>
              </StatWrapper>
            );
          }
        )}
      </Body>
    </Container>
  );
};
export default ConvertCommission;
